import React from 'react';
import moment from 'moment';
import { TableRowStyle } from '../../../pages/ClientPage.styles';

function AccidentsList({ accidents }) {
  return (
    <div className="col-6">
      <div className="card">
        <div className="card-header bg-success text-white">
          <h2 className="h3 mb-0 card-title">Sinistri</h2>
        </div>
        <div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Indirizzo</th>
                <th scope="col">Data Creazione</th>
                <th scope="col">Stato</th>
                <th scope="col">Note</th>
              </tr>
            </thead>
            <tbody>
              <TableRowStyle>
                {accidents.length !== 0 ? (
                  accidents.map((accident, index) => (
                    <React.Fragment key={index}>
                      <td>{accident.address}</td>
                      <td>
                        {moment(accident.created_at).format('DD-MM-YYYY')}
                      </td>
                      <td>
                        {accident.status === 'active' ? 'Attivo' : 'Chiuso'}
                      </td>
                      <td>
                        <button className="btn btn-success btn-sm">Vedi</button>
                      </td>
                    </React.Fragment>
                  ))
                ) : (
                  <td colSpan={4}>Nessun Sinistro Trovato</td>
                )}
              </TableRowStyle>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AccidentsList;
